<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 345px;}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 99%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox" >
      <table>
        <tr class="ssgj_tr">
          <td class="td_left">会议选择</td>
          <td class="after" style="display: flex;">
            <el-form-item>
                <el-select v-model="form.meetingid" placeholder="请选择" class="input">
                  <el-option
                    class="input"
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">会议日程</td>
          <td class="after" style="display: flex;">
            <el-form-item style="margin-right:15px">
              <el-date-picker v-model="form.days" :transfer="true" popper-class='mzindex' type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy 年 MM 月 dd 日"></el-date-picker>
            </el-form-item>
            <!-- <el-form-item style="margin-right:15px">
              <el-time-picker is-range popper-class='mzindex' v-model="form.times" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="HH:mm" placeholder="选择时间范围"></el-time-picker>
            </el-form-item>
            <el-form-item style="margin-right:15px">
              <el-input v-model="form.content" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item style="margin-right:15px;height: 36px;">
              <i class="el-icon-circle-plus-outline" style="font-size:34px" @click="getDhycAry"></i>
            </el-form-item> -->
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">会议时间选择</td>
          <td class="after" style="display: flex;">
            <el-form-item>
                <el-select v-model="form.type" placeholder="请选择" class="input">
                  <el-option
                    class="input"
                    v-for="item in optionsType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">会议地点</td>
          <td class="after" style="display: flex;">
            <el-form-item style="margin-right:15px">
              <el-input v-model="form.address" placeholder="请输入地点"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">日程内容</td>
          <td class="after" style="display: flex;">
            <el-form-item style="margin-right:15px">
              <!-- <el-input type="textarea" :rows="2" v-model="form.content" placeholder="请输入内容"></el-input> -->
              <div id="editor" style="position:relative;z-index: 1;"></div>
            </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">日程关联ID</td>
          <td class="after" style="display: flex;">
            <el-form-item>
              <el-form-item>
                <el-input v-model="form.glid" class="input title"></el-input>
              </el-form-item>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addHyrc" v-if="this.$route.path === '/Processgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/ProcessUpdate'">确定修改</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Processgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/ProcessUpdate'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * lx
 * 大会议程发布
 */
import {mapState} from 'vuex'
// import E from 'wangeditor'
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      url: '',
      // dhycList: [],
      // days: '',
      // times: '',
      // content: '',
      // meetingid: '',
      // glid: '',
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      form: {
        meetingid: null,
        days: '',
        type: null,
        address: '',
        content: '',
        glid: null
      },
      //状态分类
      statusary: [
        {
          value: '召集中',
          label: '召集中'
        },
        {
          value: '召开中',
          label: '召开中'
        },
        {
          value: '已召开',
          label: '已召开'
        }
      ],
      options1: [],
      optionsType: [
        { value: '0', label: '上午' },
        { value: '1', label: '下午' },
        { value: '2', label: '午餐' },
        { value: '3', label: '晚餐' }
      ],

      examine: '',
      //表名
      tabname: 'dmcn_hyrc',
      //fld表数据
      fldData: [],
      fldContentData: []
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      nodeid: state => state.NavID
    }),
    Url()
    {
      return this.url
    }
  },
  watch:
  {
    nodeid:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(this.nodeid, 'type').then(res =>
        {
          this.classifydata = []
          res.forEach(e => this.classifydata.push({ value: e.dispc, label: e.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    this.getoptions()
    this.getDhycAry()
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
    // 先拉数据再创建编辑器：content 入库是编码态，由 createEditor 解码后回填
    await this.isgetData()
    this.$nextTick(() =>
    {
      window.public.createEditor(this)
    })
  },
  methods: {
    getoptions()
    {
      let obj = {
        cmd: 'query',
        _major: 11,
        _minor: 105,
        _exp: 'id > 0'
      }
      window.post.getPost(obj).then(ret =>
      {
        this.options1 = []
        ret.forEach(item =>
        {
          this.options1.push(
            {
              value: item.id,
              label: item.name
            }
          )
        })
      })
    },
    //添加会议日程
    addHyrc()
    {
      let param = {
        cmd: 'add',
        _major: 11,
        _minor: 34,
        retAtt: 1,
        catid: 421,
        meetingid: this.form.meetingid,
        data: this.form.days,
        type: this.form.type,
        address: this.form.address,
        content: this.form.content,
        glid: this.form.glid
      }
      window.post.getPost(param).then(ret =>
      {
        if (ret.id)
        {
          this.$message({message: '大会议程添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
        else
          this.$message({message: '大会议程上传失败', type: 'error', customClass: 'mzindex'})
      })
    },
    async isgetData()
    {
      if (this.$route.path === '/ProcessUpdate')
        await this.getHyrc()
    },
    //获取会议日程
    getHyrc()
    {
      let params = {
        cmd: 'query',
        _major: 11,
        _minor: 34,
        _exp: `id = ${this.updataID}`
      }
      return window.post.getPost(params).then(res =>
      {
        this.form.meetingid = res[0].meetingid
        this.form.days = res[0].data
        this.form.type = res[0].type
        this.form.address = res[0].address
        // 只写入 form.content（编码态），等 createEditor 创建后再解码回填
        this.form.content = res[0].content || ''
        this.form.glid = res[0].glid
      })
    },
    //确定修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 34,
        retAtt: 1,
        id: this.updataID,
        data: this.form.days,
        type: this.form.type,
        meetingid: this.form.meetingid,
        glid: this.form.glid,
        address: this.form.address,
        content: this.form.content
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          // 内容修改
          // this.updaeContent()
          // 会议日程修改
          // this.modifyHyrc()
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.$router.push({path: '/Processgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    // 点击获取大会议程
    getDhycAry()
    {
      // this.dhycList.push({days: '', times: '', content: ''})
    },
    //修改会议日程
    delHyrc(ary)
    {
      let cont = {cmd: 'deletes', _major: 11, _minor: 34, ids: `${Array.from(ary, e => e.id).join(',')}`}
      return window.post.getPost(cont)
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Processgl'})
      this.$store.commit('onActiveName', '1')
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/ProcessAdd.vue